import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MarketplaceApiService, MarcaResumen, SedeCercana } from '../services/marketplace-api.service';
import { MarketplaceAuthService } from '../services/marketplace-auth.service';
import { AuthModalService } from '../services/auth-modal.service';
import { Rubro, RUBROS } from '../models/marketplace.models';
import { SeoService } from '../../shared/seo/seo.service';
import { seoHome } from '../seo-marketplace';

@Component({
  selector: 'app-marketplace-home',
  standalone: true,
  imports: [CommonModule, RouterLink],
  styles: [`
    :host{ display:block; background:var(--bg,#eef2f8); min-height:100vh;
      --ink:#12263a; --muted:#778798; --line:#e9eef5; --card:#fff; --accent:#00A7DB; }
    *{ box-sizing:border-box; }
    .shell{ max-width:520px; margin:0 auto; padding-bottom:40px; }

    /* ---- Hero ---- */
    .hero{ position:relative; color:#fff; padding:16px 18px 60px;
      background:linear-gradient(150deg,#00A7DB 0%, #0d5f8f 100%);
      border-radius:0 0 26px 26px; overflow:hidden; }
    .hero::after{ content:''; position:absolute; inset:0; background:radial-gradient(120% 90% at 85% 0%, rgba(255,255,255,.18), transparent 60%); pointer-events:none; }
    .nav{ display:flex; align-items:center; justify-content:space-between; position:relative; z-index:1; }
    .brand{ display:inline-flex; align-items:center; gap:8px; font-weight:800; font-size:1.02rem; }
    .brand .dot{ width:28px; height:28px; border-radius:50%; background:#fff; color:#0d5f8f; display:grid; place-items:center; font-weight:900; }
    .acct{ display:flex; gap:12px; align-items:center; font-size:13px; }
    .acct a{ color:#fff; cursor:pointer; text-decoration:none; }
    .acct .link{ font-weight:700; }
    .acct .out{ text-decoration:underline; opacity:.9; }
    .hero h1{ margin:20px 0 6px; font-size:1.55rem; line-height:1.14; font-weight:800; position:relative; z-index:1; }
    .hero p{ margin:0; font-size:13.5px; opacity:.95; position:relative; z-index:1; }
    .search{ margin-top:16px; display:flex; background:#fff; border-radius:999px; padding:5px 5px 5px 16px;
      box-shadow:0 12px 30px rgba(9,50,80,.18); position:relative; z-index:1; align-items:center; }
    .search input{ border:0; outline:0; flex:1; min-width:0; padding:9px 0; font-size:15px; color:var(--ink); background:transparent; }
    .search button{ border:0; background:#0d5f8f; color:#fff; border-radius:999px; padding:10px 18px; font-weight:700; cursor:pointer; white-space:nowrap; }

    /* ---- Chips de rubro (scroll horizontal) ---- */
    .chips{ display:flex; gap:9px; overflow-x:auto; padding:16px 12px 4px; scrollbar-width:none; }
    .chips::-webkit-scrollbar{ display:none; }
    .chip{ flex:0 0 auto; background:#fff; border:1.5px solid var(--line); border-radius:999px; padding:8px 15px;
      font-weight:700; font-size:13.5px; cursor:pointer; color:#33475b; transition:.15s; white-space:nowrap; }
    .chip:hover{ border-color:var(--accent); color:var(--accent); }
    .chip.active{ background:var(--accent); color:#fff; border-color:var(--accent); }

    .count{ color:var(--muted); font-size:13px; font-weight:600; margin:8px 16px 12px; }

    /* ---- Lista de negocios ---- */
    .list{ padding:0 12px; display:flex; flex-direction:column; gap:12px; }
    .card{ background:var(--card); border:1px solid var(--line); border-radius:16px; padding:14px;
      box-shadow:0 8px 22px rgba(15,60,95,.07); text-decoration:none; color:inherit; display:flex; gap:13px;
      align-items:center; transition:transform .15s, box-shadow .15s; }
    .card:hover{ transform:translateY(-2px); box-shadow:0 14px 30px rgba(15,60,95,.13); }
    .avatar{ width:60px; height:60px; border-radius:16px; color:#fff; font-weight:800; font-size:25px;
      display:grid; place-items:center; flex:none; box-shadow:0 6px 16px rgba(0,0,0,.14); overflow:hidden; }
    .avatar img{ width:100%; height:100%; object-fit:cover; }
    .info{ flex:1; min-width:0; }
    .top-row{ display:flex; align-items:center; gap:8px; }
    .name{ font-size:1.05rem; font-weight:800; color:var(--ink); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
    .fav{ flex:none; color:#e6a400; font-size:12px; font-weight:800; }
    .rubro{ display:inline-block; margin-top:3px; border-radius:999px; padding:2px 10px; font-weight:700; font-size:11.5px; text-transform:capitalize; }
    .desc{ font-size:12.5px; color:var(--muted); margin:6px 0 0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
    .meta{ display:flex; align-items:center; gap:10px; flex-wrap:wrap; font-size:12.5px; color:#48586a; margin-top:8px; }
    .stars{ color:#f5a623; font-weight:700; }
    .pill{ background:#eef2f7; color:#48586a; border-radius:999px; padding:2px 10px; font-weight:700; font-size:11.5px; }
    .from{ margin-left:auto; font-weight:800; color:var(--ink); white-space:nowrap; }
    .from small{ font-weight:500; color:var(--muted); }
    .empty{ text-align:center; color:var(--muted); padding:60px 20px; }

    /* ---- Cerca de mí ---- */
    .cerca-btn{ flex:0 0 auto; background:#0d5f8f; color:#fff; border:0; border-radius:999px; padding:8px 15px;
      font-weight:700; font-size:13.5px; cursor:pointer; white-space:nowrap; }
    .cerca-btn:disabled{ opacity:.6; cursor:default; }
    .cerca{ margin:6px 12px 18px; background:#fff; border:1px solid var(--line); border-radius:16px; overflow:hidden;
      box-shadow:0 8px 22px rgba(15,60,95,.07); }
    .cerca h2{ font-size:1rem; font-weight:800; color:var(--ink); margin:14px 16px 4px; }
    .cerca .nota{ font-size:12.5px; color:var(--muted); margin:0 16px 10px; }
    .sede-row{ display:flex; align-items:center; gap:12px; padding:11px 16px; border-top:1px solid var(--line);
      text-decoration:none; color:inherit; }
    .sede-row:hover{ background:#f6f9fc; }
    .sede-row .km{ flex:none; min-width:58px; text-align:center; font-weight:800; color:#0d5f8f; font-size:13px;
      background:#e8f6fc; border-radius:10px; padding:6px 4px; }
    .sede-row .txt{ flex:1; min-width:0; }
    .sede-row .n{ font-weight:800; color:var(--ink); font-size:14px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
    .sede-row .d{ font-size:12px; color:var(--muted); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
    .sede-row .p{ flex:none; font-weight:800; font-size:13px; color:var(--ink); }
    .llegar{ display:block; padding:0 16px 10px 86px; margin-top:-4px; font-size:12.5px; font-weight:700;
      color:#0d5f8f; text-decoration:none; }

    /* ---- Tablet: 2 columnas ---- */
    @media (min-width:900px){
      .shell{ max-width:1120px; }
      .hero{ border-radius:0 0 30px 30px; padding-bottom:56px; }
      .hero h1{ font-size:1.9rem; }
      .nav, .hero h1, .hero p, .search{ max-width:680px; margin-left:auto; margin-right:auto; }
      .chips{ flex-wrap:wrap; overflow:visible; padding-left:16px; padding-right:16px; }
      .count{ margin-left:16px; }
      .list{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); align-items:stretch; }
      .card{ align-items:flex-start; }
    }
    /* ---- Desktop: 3-4 columnas ---- */
    @media (min-width:1200px){
      .list{ grid-template-columns:repeat(auto-fill,minmax(330px,1fr)); }
    }
  `],
  template: `
  <div class="shell">
    <section class="hero">
      <div class="nav">
        <div class="brand"><span class="dot">A</span> Aura</div>
        <div class="acct">
          @if (auth.user(); as u) {
            <span style="opacity:.9;">Hola, {{ u.nombre || u.email }}</span>
            <a class="link" [routerLink]="['/marketplace', 'mi-cuenta']">Mi cuenta</a>
            <a class="out" (click)="auth.logout()">Salir</a>
          } @else {
            <a class="link" (click)="authModal.open('login')">Ingresar</a>
          }
        </div>
      </div>
      <h1>Reserva en los mejores spas, dentistas y salones</h1>
      <p>Elige tu profesional, tu sede y reserva con un pequeño adelanto.</p>
      <div class="search">
        <input [value]="q" (input)="onSearch($any($event.target).value)" placeholder="Buscar por nombre o servicio…" aria-label="Buscar negocios" />
        <button type="button" aria-label="Buscar">Buscar</button>
      </div>
    </section>

    <div class="chips">
      <button class="chip" [class.active]="rubro==='todos'" type="button" (click)="filter('todos')">Todos</button>
      @for (r of rubros; track r.key) {
        <button class="chip" [class.active]="rubro===r.key" type="button" (click)="filter(r.key)">{{ r.icon }} {{ r.label }}</button>
      }
    </div>

    <div class="chips" style="padding-top:4px">
      <button class="cerca-btn" type="button" (click)="cercaDeMi()" [disabled]="ubicando">
        {{ ubicando ? 'Buscando tu ubicación…' : (ubicacion ? '📍 Actualizar ubicación' : '📍 Cerca de mí') }}
      </button>
    </div>
    @if (errorUbicacion) { <div class="count" style="color:#b3261e">{{ errorUbicacion }}</div> }

    @if (ubicacion) {
      <section class="cerca" aria-label="Sedes más cercanas">
        <h2>Más cerca de vos{{ q.trim() ? ' · ' + q.trim() : '' }}</h2>
        <p class="nota">Ordenadas por distancia. Tu ubicación sólo se usa para ordenar esta lista.</p>
        @for (s of cercanas; track s.idSede) {
          <a class="sede-row" [routerLink]="['/marketplace', s.marcaSlug, s.sedeSlug]">
            <span class="km">{{ s.distanciaKm != null ? (s.distanciaKm < 1 ? (s.distanciaKm * 1000 | number:'0.0-0') + ' m' : s.distanciaKm + ' km') : '—' }}</span>
            <span class="txt">
              <div class="n">{{ s.marcaNombre }} · {{ s.sede }}</div>
              <div class="d">{{ s.servicio ? s.servicio + ' · ' : '' }}{{ s.direccion }}</div>
            </span>
            @if (s.desde != null) { <span class="p">S/ {{ s.desde }}</span> }
          </a>
          <a class="llegar" [href]="comoLlegar(s)" target="_blank" rel="noopener">Cómo llegar ↗</a>
        } @empty {
          <p class="nota">{{ cargandoCercanas ? 'Buscando…' : 'No hay sedes que coincidan con tu búsqueda.' }}</p>
        }
      </section>
    }

    <div class="count">{{ visibles.length }} negocio(s) disponibles</div>

    @if (visibles.length) {
      <div class="list">
        @for (m of visibles; track m.idEmpresa) {
          <a class="card" [routerLink]="['/marketplace', m.slug]" [attr.aria-label]="'Ver ' + m.nombre">
            <div class="avatar" [style.background]="'linear-gradient(150deg,'+color(m)+','+color(m)+'cc)'">
              @if (m.logoUrl) { <img [src]="m.logoUrl" alt="" loading="lazy" /> }
              @else { {{ m.nombre.charAt(0) }} }
            </div>
            <div class="info">
              <div class="top-row">
                <span class="name">{{ m.nombre }}</span>
                @if (m.destacado) { <span class="fav">★ Destacado</span> }
              </div>
              <span class="rubro" [style.background]="color(m)+'1f'" [style.color]="color(m)">{{ rubroLabel(m.rubro) }}</span>
              @if (m.descripcion) { <p class="desc">{{ m.descripcion }}</p> }
              <div class="meta">
                <span class="stars">★ {{ m.rating }}</span>
                <span style="color:#98a6b5">({{ m.resenas }})</span>
                <span class="pill">{{ m.sedes }} sede(s)</span>
                <span class="from">desde <small>S/</small> {{ m.desde }}</span>
              </div>
            </div>
          </a>
        }
      </div>
    } @else {
      <div class="empty">{{ cargando ? 'Cargando…' : 'No encontramos negocios para tu búsqueda.' }}</div>
    }
  </div>
  `,
})
/**
 * Sin badge de "Cerrado ahora" a propósito: `GET /marketplace/marcas` es un listado
 * resumido (MarcaResumen trae `sedes` como CONTEO, no como array) y no incluye el
 * estado operativo. Saber si TODAS las sedes de una marca están cerradas exigiría una
 * llamada por marca (/marca/:slug o /sede/:id/estado) → N+1 en la pantalla de entrada.
 * El estado sí se muestra en marca y sede, donde ya viene embebido y no cuesta nada.
 * Si algún día el listado expone el estado agregado por marca, el badge va acá.
 */
export class MarketplaceHomeComponent implements OnInit {
  rubros = RUBROS;
  rubro: Rubro | 'todos' = 'todos';
  q = '';
  cargando = true;
  marcas: MarcaResumen[] = [];
  visibles: MarcaResumen[] = [];

  // ---- Cerca de mí: sedes ordenadas por distancia (GET /marketplace/sedes/cercanas) ----
  // Sin mapa embebido por ahora (la API de Google Maps cobra; ver MapaSedesComponent):
  // lista ordenada + "Cómo llegar", que abre Google Maps gratis.
  ubicacion: { lat: number; lng: number } | null = null;
  ubicando = false;
  errorUbicacion = '';
  cercanas: SedeCercana[] = [];
  cargandoCercanas = false;
  private buscarTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private api: MarketplaceApiService,
    public auth: MarketplaceAuthService,
    public authModal: AuthModalService,
    private cdr: ChangeDetectorRef,
    private seo: SeoService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.cargando = true;
    this.api.getMarcas(this.rubro).subscribe({
      next: (data) => {
        this.marcas = data;
        this.seo.set(seoHome(data ?? []));
        this.applySearch();
        this.cargando = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.cargando = false;
        this.cdr.detectChanges();
      },
    });
  }

  filter(r: Rubro | 'todos'): void {
    this.rubro = r;
    this.load();
    if (this.ubicacion) this.cargarCercanas();
  }

  onSearch(value: string): void {
    this.q = value ?? '';
    this.applySearch();
    // Con la ubicación activa, la búsqueda también filtra las cercanas ("baño", "vacuna").
    if (this.ubicacion) {
      if (this.buscarTimer) clearTimeout(this.buscarTimer);
      this.buscarTimer = setTimeout(() => this.cargarCercanas(), 350);
    }
  }

  /** Pide la ubicación al navegador. Si la niega, se explica y no se insiste. */
  cercaDeMi(): void {
    this.errorUbicacion = '';
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      this.errorUbicacion = 'Tu navegador no permite obtener la ubicación.';
      return;
    }
    this.ubicando = true;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        this.ubicando = false;
        this.ubicacion = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        this.cargarCercanas();
      },
      (err) => {
        this.ubicando = false;
        this.errorUbicacion =
          err.code === err.PERMISSION_DENIED
            ? 'Para ver lo más cercano, permití el acceso a tu ubicación en el navegador.'
            : 'No pudimos obtener tu ubicación. Probá de nuevo.';
        this.cdr.detectChanges();
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 },
    );
  }

  private cargarCercanas(): void {
    if (!this.ubicacion) return;
    this.cargandoCercanas = true;
    this.api
      .getSedesCercanas({ ...this.ubicacion, rubro: this.rubro, q: this.q })
      .subscribe({
        next: (sedes) => {
          this.cercanas = sedes;
          this.cargandoCercanas = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.cercanas = [];
          this.cargandoCercanas = false;
          this.cdr.detectChanges();
        },
      });
  }

  /** Link gratis a Google Maps: el que cargó el negocio, si no sus coordenadas, si no la dirección. */
  comoLlegar(s: SedeCercana): string {
    if (s.mapsUrl) return s.mapsUrl;
    const destino = s.lat != null && s.lng != null ? `${s.lat},${s.lng}` : `${s.direccion ?? ''} ${s.sede}, Lima`;
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destino)}`;
  }

  applySearch(): void {
    const q = this.q.trim().toLowerCase();
    this.visibles = !q
      ? this.marcas
      : this.marcas.filter(
          (m) => m.nombre.toLowerCase().includes(q) || m.descripcion.toLowerCase().includes(q),
        );
  }

  color(m: MarcaResumen): string {
    return MarketplaceApiService.colorDe(m);
  }
  rubroLabel(r: Rubro): string {
    return this.rubros.find((x) => x.key === r)?.label ?? r;
  }
}
